import common from "./common";
import live from "./live";
import historical from "./historical";
import ensight from "./ensight";
import info from "./info";
import customization from "./customization";
import notifications from "./notifications";
import billReconciliation from "./billReconciliation";
import offGrid from "./offGrid";
import complaintTicket from "./complaintTicket";
import efficiencyInitiatives from "./efficiencyInitiatives";
import environment from "./environment";
import chatbot from "./chatbot";

// One namespace per tab; ids look like "live.totalLoad".
const registry = {
  common,
  live,
  historical,
  ensight,
  info,
  customization,
  notifications,
  billReconciliation,
  offGrid,
  complaintTicket,
  efficiencyInitiatives,
  environment,
  chatbot,
};

export const getFieldHelp = (id) => {
  if (!id) return null;
  const dot = id.indexOf(".");
  if (dot < 0) return null;
  return registry[id.slice(0, dot)]?.[id.slice(dot + 1)] || null;
};
